export class UI {
    private wrapper: HTMLElement;
    private _col1: HTMLElement;
    private _col2: HTMLElement;

    constructor(wrapper: HTMLElement) {
        this.wrapper = wrapper;

        // Add columns
        this._col1 = document.createElement("div");
        this._col2 = document.createElement("div");
    }

    buildUi(): void {
        this.wrapper.classList.add("d-flex", "flex-wrap");

        // Set column 1
        this._col1.id = "ahrb-col1";
        this._col1.classList.add("px-3");
        this._col1.innerHTML = "<h4 class='font-weight-bold'>Saved Reports</h4>";
        this.wrapper.append(this._col1);
        // Add saved report wrapper to col1
        // this.savedReportsWrapper = document.createElement("div");
        // this.savedReportsWrapper.id = "ahrb-reports-wrapper";
        // col1.append(this.savedReportsWrapper);

        // Set column 2
        this._col2.id = "ahrb-col2";
        this._col2.classList.add("px-3");
        this.wrapper.append(this._col2);
    }

    /**
     * Set loading animation
     * 
     * @param {boolean} finishedLoading
     */
    setLoading(isLoading: boolean = true): void {
        if (isLoading) {
            this.wrapper.classList.add("loading");
        } else {
            this.wrapper.classList.remove("loading");
        }
    }

    /**
     * Get column 1 element
     * 
     * @returns {HTMLElement} The column 1 element
     */
    get col1(): HTMLElement {
        return this._col1;
    }

    /**
     * Get column 2 element
     * 
     * @returns {HTMLElement} The column 2 element
     */
    get col2(): HTMLElement {
        return this._col2;
    }
}